import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../data/content";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="mb-12 text-center">
          <p className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-5">
            Preguntas Frecuentes
          </p>
          <h2 className="font-serif-display text-3xl md:text-5xl font-semibold text-[#2D1B4E] tracking-tight leading-[1.1]">
            Resolvemos tus dudas.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#E8E4EE]">
              <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl font-medium text-[#2D1B4E] hover:text-[#5B3E96] hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5F5670] text-base leading-relaxed pb-6">
                {item.a && <p>{item.a}</p>}
                {item.bullets && (
                  <ul className="mt-3 space-y-2">
                    {item.bullets.map((b, bi) => (
                      <li key={bi} className="flex items-start gap-2">
                        <span className="text-[#5B3E96] mt-1">•</span>
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {item.note && (
                  <p className="mt-4 text-sm font-semibold text-[#7A5B12] bg-[#FBF7E9] border border-[#EADFAE] rounded-sm px-4 py-3">
                    Nota: {item.note}
                  </p>
                )}
                {item.important && (
                  <p className="mt-3 text-sm font-semibold text-[#A23B3B] bg-[#FBECEC] border border-[#E7C9C9] rounded-sm px-4 py-3">
                    Importante: {item.important}
                  </p>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
